import React from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Format from "../../../../helpers/Format";

import style from "./styles.module.scss";

const keyI18n = "translations.validateSignature";

interface SignatureCardProps {
  date: string | null;
  name: string;
}

export default function SignatureCard({ date, name }: SignatureCardProps) {
  const { t } = useTranslation();
  const signedAt = date && moment(date, moment.ISO_8601, true).isValid()
    ? t(`${keyI18n}.signedAt`, { date: Format.date(date, "datetime") })
    : t(`${keyI18n}.signatureDateUnavailable`);

  return (
    <article className={style.card}>
      <h3 className={`pgm-title-medium ${style.name}`}>{name}</h3>
      <p className={`pgm-body-medium ${style.date}`}>
        {signedAt}
      </p>
    </article>
  );
}
